import Bracket from "pages/Bracket";
import React from "react";
import { useQuery } from 'react-query'
import { getResultsRSC, getEventRanking } from "data/Querys"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Loader from 'components/general/Loader'
import PageHeader from "components/common/PageHeader";
import Label from "components/general/Label";
import NotAvailable from "components/common/NotAvailable";
import RecordsPrototype from "components/general/RecordsPrototype";
import { isSpeedFinal } from "components/sports/clb/helper/ClbHelpers";
import Standings from "../events/speed/Standings";
import { getUnits } from "data/Querys";
import { getPhaseRSC } from "helpers/rsc";


const ClbSpeedFinal = ({ mirs_competition, mirs_rsc, mirs_language, breakPoint }) => {
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getResultsRSC,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    }
  )

  const { data: standigsData, isError: standingsIsError, isLoading: standingsIsLoading } = useQuery(
    {
      queryKey: ['eventRanking', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getEventRanking,
      refetchInterval: 20000,
      staleTime: 20000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    });

  //Only needed to get the header title
  const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
    {
      queryKey: ['unitsPhase', mirs_competition, mirs_language, getPhaseRSC(mirs_rsc), 'Y'],
      queryFn: getUnits,
      //refetchInterval: 30000,
      staleTime: Infinity,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    }
  );

  if (isError || unitsError || standingsIsError) { return <NotAvailable />; }
  if (isLoading || unitsLoading || standingsIsLoading) { return <Loader />; }

  let bibs = [];
  standigsData?.event?.phases?.forEach(phase => {
    phase?.units?.filter(unit => isSpeedFinal(unit?.result?.eventUnitCode))?.forEach(unit => {
      unit?.result?.items?.forEach(item => bibs.push({ code: item?.participant?.code, bib: item?.bib }))
    })
  });

  let dataWithBibs = standigsData?.event?.rankings?.map(ranking => {
    let bib = {
      bib: bibs?.find(bib => bib?.code === ranking?.participant?.code)?.bib
    }
    return ({ ...ranking, ...bib })
  }
  )?.filter(item => '|1|2|3|4|5|6|7|8|'.includes(item?.rank))

  return (<>
    <PageHeader data={data} title={!data?.results?.eventUnit?.description ? unitsData?.phase?.description : undefined} />

    {data?.records &&

      <RecordsPrototype records={data?.records} forceResultTypeHader={'HeaderPoints'} forceMobileColumns={['Date', 'Location']} />

    }

    <Tabs id="mirs-navsport" defaultActiveKey={`1-${mirs_rsc}`} className="mb-3 mirs-tab-result">

      <Tab eventKey={`1-${mirs_rsc}`} title={(<Label data='Heats' />)} >
        <Bracket />
      </Tab>

      <Tab eventKey={`2-${mirs_rsc}`} title={(<Label data='HeaderStandings' />)} disabled={!dataWithBibs || (Array.isArray(dataWithBibs) && dataWithBibs.length === 0)}>
        <Standings data={dataWithBibs} mirs_rsc={mirs_rsc} />
      </Tab>
    </Tabs>
  </>)
}

export default ClbSpeedFinal;

